'use strict';

var React = require('react');

var SvgPlayMajor = function SvgPlayMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.333 1c-.693 0-1.333.555-1.333 1.332v15.335a1.328 1.328 0 0 0 2.014 1.143l12.787-7.665a1.33 1.33 0 0 0 0-2.283l-12.786-7.67a1.326 1.326 0 0 0-.682-.192zm.667 2.515 10.815 6.488-10.815 6.482v-12.97z"
  }));
};

exports.SvgPlayMajor = SvgPlayMajor;
